import { get } from "js-cookie";
import { ONE_TRUST_COOKIE_NAME } from "../constants";
import { getConsentFromCookieString } from "../getConsentFromCookieString";

/**
 * Get the current consent from the OneTrust cookie.
 *
 * If the cookie does not exist, or does not contain the consent groups, then
 * `null` is returned.
 *
 * @returns {object|null}
 */
export const getConsentFromCookie = () => {
  const consentString = get(ONE_TRUST_COOKIE_NAME);

  if (!consentString) {
    return null;
  }

  return getConsentFromCookieString(consentString);
};
